// @ts-nocheck
/**
 *
 * SongPreviewCard cloned and tweaked from AcapellaStackProductCard
 *
 */
import * as React from 'react';
import styled from 'styled-components/macro';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPause, faPlay, faPlus, faSparkles} from '@fortawesome/pro-solid-svg-icons';
import {useDispatch, useSelector} from "react-redux";
import {useGlobalAudioSlice} from "app/components/GlobalAudioPlayer/slice";
import {selectCurrentSong, selectIsPlaying} from "app/components/GlobalAudioPlayer/slice/selectors";
import {Orbit, Pulsar, Waveform as PlayingWaveform} from '@uiball/loaders';
import {DisplaySongInfo} from "app/components/GlobalAudioPlayer/slice/types";
import {useNavigate} from "react-router-dom";
import {getStatusOfAcapellaStack, getPreviewUrlOfAcapellaStack} from "app/components/SongPreviewCard/getStatusOfAcapellaStack";
import {Button, Skeleton} from "@mui/material";
import {useState} from "react";
import {Api} from "../../../store/api";
import {useAcapellasSlice} from "app/pages/AcapellasPage/slice";

interface Props {
  uniqueKey: string,
  acapellaStack: any,
  onCustomize: Function,
  size: string, //['sm', 'default']
  previewVoice?: any,
}

export function SongPreviewCardSkeleton() {
    return (
        <SongPreviewCardSkeletonContainer>
            <Skeleton variant="rectangular" width={260} height={370} />
        </SongPreviewCardSkeletonContainer>
    );
}

export function SongPreviewCard(props: Props) {
  const navigate = useNavigate()
  const { uniqueKey, acapellaStack, hidePrice, size, previewVoice } = props;
  const { uuid, name, public_image_url: image, user_profile, acapella_stack_audio_files: audioFileObjs, acapella_stack_jobs: acapellaStackJobs, controlla_price } = acapellaStack;
  const { name: ghostSinger } = user_profile;

  const dispatch = useDispatch();
  const { actions: globalAudioActions } = useGlobalAudioSlice()
    const { actions: acapellaActions } = useAcapellasSlice()
  const currentSong = useSelector(selectCurrentSong)
  const isPlaying = useSelector(selectIsPlaying)
  const [isQueueingPreview, setIsQueueingPreview] = useState(false)


  // const audioFiles = audioFileObjs.filter(a => a.type === 'vocal-stem-preview').map(a => a.audio_file.storagePublicUrl)

    // If multiple previews are returned, get highest ID for most recent one
  const mixdownPreviewFiles = audioFileObjs.filter(a => a.type === 'preview').map(a => a.audio_file.storagePublicUrl)
  // ChatGPT: const highestIdObject = arrayOfObjects.reduce((a, b) => (a.id > b.id ? a : b), {});
  const mixdownAudioFile = mixdownPreviewFiles.reduce((a, b) => (a.id > b.id ? a : b), {});

  const isSizeSmall = (size === 'sm');

  const handleCustomize = () => {
    props.onCustomize(acapellaStack)
  }

    const handlePlay = () => {
        // Create DisplaySong object for main preview
        const displaySong :DisplaySongInfo = {
            title: name,
            singer: ghostSinger,
            url: mainAudioPreviewUrl,
            coverUrl: image,
            acapellaStack: acapellaStack,
        }

        dispatch(globalAudioActions.setCurrentSong(displaySong))
        dispatch(globalAudioActions.setIsPlaying(true))
    }

    const handlePlayOriginal = () => {
        // Create DisplaySong object for original preview
        const displaySong :DisplaySongInfo = {
            title: name,
            singer: ghostSinger,
            url: mixdownAudioFile,
            coverUrl: image,
            acapellaStack: acapellaStack,
        }

        dispatch(globalAudioActions.setCurrentSong(displaySong))
        dispatch(globalAudioActions.setIsPlaying(true))
    }

    const handlePause = () => {
        dispatch(globalAudioActions.setIsPlaying(false))
    }

    const handleGeneratePreview = () => {
        setIsQueueingPreview(true)
        Api.generateAcapellaStackPreview(previewVoice.uuid, acapellaStack.uuid).then(() => {
            //refresh songs
            dispatch(Object.assign(acapellaActions.fetchAcapellas(), { payload: { voice: previewVoice, isPolling: true }}));
            setIsQueueingPreview(false)
        }).catch((e) => {
            setIsQueueingPreview(false)
        })
    }

    const handleCancelPreview = () => {
      console.log('TODO DELETE JOB')
    }

  // Which text/button/audio to display in preview?
  let mainAudioPreviewUrl = mixdownAudioFile
  // default to pulsing animation QUEUED
  let borderElement = <div className="animate-border-pulse"></div>
  // Captions when hovering but not playing
  let playButtonCaption = "Waiting for preview in your voice"
  if (!previewVoice) playButtonCaption = "Select a voice to preview in your voice"
  // Captions when hovering and playing, other caption defined in status logic above
  if (isPlaying && currentSong?.url === mainAudioPreviewUrl) {
        playButtonCaption = "Playing in your voice"
  }
  if (isPlaying && currentSong?.url === mixdownAudioFile) {
        playButtonCaption = "Playing original"
  }

  let mainHoverButton = (null)
  let mainActionButton = (
      <SongActionButton disabled={isQueueingPreview} onClick={handleGeneratePreview} startIcon={<FontAwesomeIcon icon={faSparkles} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="solid" >
          {isQueueingPreview ? 'Generating ' : 'Generate '} Preview
      </SongActionButton>
  )

  let acapellaStackPreviewStatus = getStatusOfAcapellaStack(acapellaStack)
  // EMPTY status is returned by getStatusOfAcapellaStack if no preview jobs found, doesn't exist as a status in db
  if (acapellaStackPreviewStatus === 'EMPTY') {
      mainActionButton = (
          <SongActionButton disabled={isQueueingPreview} onClick={handleGeneratePreview} startIcon={<FontAwesomeIcon icon={faSparkles} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="solid" >
              {isQueueingPreview ? 'Generating ' : 'Generate '} Preview
          </SongActionButton>
      )
  }
  if (acapellaStackPreviewStatus === 'CREATED') {
      borderElement = null
      if (previewVoice) {
          playButtonCaption = "Queued in your voice"
          mainHoverButton = (
              <MainPlayButton>
                  <Pulsar color={'#FFF'} size={18} speed={1} />
              </MainPlayButton>
          )
          mainActionButton = (
              // TODO DELETE JOB
              <SongActionButton disabled={true} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="text" >
                  Queued
              </SongActionButton>
          )
      }
  } else if (acapellaStackPreviewStatus === 'STARTED') {
      borderElement = <div className="animate-border-trail"></div>
      if (previewVoice) {
          playButtonCaption = "Generating in your voice"
          mainHoverButton = (
              <MainPlayButton>
                  <Orbit color={'#FFF'} size={18} speed={1} />
              </MainPlayButton>
          )
          mainActionButton = (
              // TODO allow notify me?
              <SongActionButton disabled={true} startIcon={<FontAwesomeIcon icon={faSparkles} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="text" >
                  In Progress
              </SongActionButton>
          )
      }
  } else if (acapellaStackPreviewStatus === 'COMPLETED') {
      mainAudioPreviewUrl = getPreviewUrlOfAcapellaStack(acapellaStack)
      borderElement = null
      playButtonCaption = "Play in your voice"
      mainHoverButton = (
          <MainPlayButton onClick={handlePlay}>
              <FontAwesomeIcon icon={faPlay} />
          </MainPlayButton>
      )
      mainActionButton = (
          <SongActionButton variant={"solid"} color={"primary"} onClick={handleCustomize} startIcon={<FontAwesomeIcon icon={faPlus} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="text" >
              Get Full Song
          </SongActionButton>
      )
  }

  if (!previewVoice) {
      borderElement = null
      mainActionButton = (
          <SongActionButton onClick={handleCustomize} startIcon={<FontAwesomeIcon icon={faSparkles} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden" }} size="small" variant="solid" >
              Customize
          </SongActionButton>
      )
  }


    // if currently playing this song, show pause button instead
    if (isPlaying && currentSong?.url === mainAudioPreviewUrl) {
        mainHoverButton = (
            <MainPlayButton onClick={handlePause}>
                <FontAwesomeIcon icon={faPause} />
            </MainPlayButton>
        )
    }


  let playOriginalButton = (
      <PlayOriginalButton onClick={handlePlayOriginal}>
          <FontAwesomeIcon icon={faPlay} />
          Original
      </PlayOriginalButton>
  )
  if (isPlaying && currentSong?.url === mixdownAudioFile) {
      playOriginalButton = (
          <PlayOriginalButton onClick={handlePause}>
              <FontAwesomeIcon icon={faPause} />
              Original
          </PlayOriginalButton>
      )
  }

  const thumbnailHoverActions = (
    <ThumbnailHoverActions>
      {/* Play Original button plays the ghost singer mixdown */}
      {playOriginalButton}
      {/* Main play button plays/pauses preview in selected voice */}
      {mainHoverButton}
      <MainPlayText>
        {playButtonCaption}
      </MainPlayText>
    </ThumbnailHoverActions>
  );

  // @ts-ignore
  // @ts-ignore
  return <SongPreviewCardContainer inactive={acapellaStackPreviewStatus === 'CREATED'}>
    <ThumbnailCol>
      <ThumbnailImageContainer>
        {thumbnailHoverActions}
        <ThumbnailImage src={image}  small={isSizeSmall}/>
      </ThumbnailImageContainer>
      <ThumbnailPreviewContent>
        <NameSingerAndPrice>
          <NameSinger>
            <Name onClick={handlePlay} small={isSizeSmall}>
                {(currentSong?.url === mainAudioPreviewUrl || currentSong?.url === mixdownAudioFile) && (
                    <NowPlayingWaveformIndicator>
                        <PlayingWaveform size={18} color={'#ff74e9'} lineWeight={3} speed={isPlaying ? 1 : 1000}/>
                    </NowPlayingWaveformIndicator>
                )}
                {name}
            </Name>
            <GhostSinger small={isSizeSmall}>{'Cover by ' + ghostSinger}</GhostSinger>
          </NameSinger>
        </NameSingerAndPrice>
      </ThumbnailPreviewContent>
    </ThumbnailCol>
    {mainActionButton}

    {borderElement}
  </SongPreviewCardContainer>;
}

SongPreviewCard.defaultProps = {
  uniqueKey: '',
  hidePrice: true,
  size: 'default',
}

const ThumbnailCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  
  z-index: 1;

`;

// needs to be defined for nested hover styled on SongPreviewCard
const ThumbnailHoverActions = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  
  z-index: 1;
  background: #0C081033;

  display: none; // on hover show (SongPreviewCard styles at top of this files' styled components)
`;

const SongPreviewCardContainer = styled.div<{ inactive?: boolean; }>`
  
  background-color: ${props => props.inactive ? '#1D0D2C99' : '#1D0D2C'};
  border-radius: 20px;
  border: ${props => props.inactive ? '1px solid #f5e1ff11' : '1px solid #f5e1ff33'};
  padding: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  
  margin-bottom: 40px;
  position: relative;
  width: 260px;
  margin-right: 20px;
  transition: border 0.2s ease;
  
  &:hover {
    border: 1px solid rgba(255, 116, 233, 0.99);
    opacity: ${props => props.inactive ? 0.9 : 1};

    ${ThumbnailHoverActions} {
      display: block;
    }
  }
  
  ${ThumbnailCol} {
    opacity: ${props => props.inactive ? 0.6 : 1};
  }

  @media only screen and (max-width: 600px) {
    margin-left: 40px;
  }
`;
const SongPreviewCardSkeletonContainer = styled.div`
  margin-bottom: 40px;
  position: relative;
  margin-right: 20px;
  border-radius: 20px;

  @media only screen and (max-width: 600px) {
    margin-left: 40px;
  }
`;



const ThumbnailImageContainer = styled.div`
  width: ${props => props.small ? '140px' : '220px'};
  flex-grow: 0;
  align-self: center;
  border-radius: 15px;
  margin-bottom: 10px;
  position: relative;

  @media only screen and (max-width: 600px) {
    width: 220px;
  }
`;

const ThumbnailImage = styled.img`
  width: 100%;
`;
const ThumbnailPreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  flex-grow: 1;
  margin-bottom: 20px;
`;
const NameSingerAndPrice = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
`;
const NameSinger = styled.div`
  flex-grow: 1;
  text-align: left;
`;
const Name = styled.div`
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: ${props => props.small ? '24px' : '24px'};
  line-height: ${props => props.small ? 'normal' : 'normal'};

  color: #FFF;
  margin-top: 10px;
  margin-bottom: 10px;

  @media only screen and (max-width: 600px) {
    line-height: ${props => props.small ? '24px' : '24px'};
    font-size: ${props => props.small ? 'normal' : 'normal'};
  }
`;

const GhostSinger = styled.div`
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 300;
  font-size: ${props => props.small ? '16px' : '16px'};
  line-height: ${props => props.small ? 'normal' : 'normal'};

  color: rgba(245, 225, 255, 0.74);
  margin-top: 0px;
  margin-bottom: 0px;

@media only screen and (max-width: 600px) {
    font-size: ${props => props.small ? '14px' : '18px'};
    line-height: ${props => props.small ? '16px' : '20px'};
  }
`;
const PriceDiscount = styled.div`
  position: absolute;
  top: 2.5em;
  right: 0;

  color: #59C1BD;
  text-align: center;
  font-family: Jura;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
const OldPrice = styled.div`
  color: rgba(245, 225, 255, 0.74);
  text-align: center;
  font-family: Jura;
  font-size: 36px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-decoration: line-through;
  padding-right: 5px;
`;
const Price = styled.div`
  color: #FFF;
  text-align: right;
  font-family: Jura;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-right: 0px;
  
  position: relative;
`;

const ThumbnailActionsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  
  padding-top: 20px;
`;

const ThumbnailStat = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-right: 20px;
`;
const ThumbnailStatLabel = styled.div`
  color: rgba(245, 225, 255, 0.74);
  text-align: center;
  text-overflow: ellipsis;
  whitespace: nowrap;
  font-family: Jura;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
const ThumbnailStatValue = styled.div`
  color: rgba(245, 225, 255, 0.74);
  text-align: center;
  text-overflow: ellipsis;
  whitespace: nowrap;
  font-family: Jura;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
const TermsLabel = styled.div`
  color: rgba(245, 225, 255, 0.74);
  text-align: left;
  text-overflow: ellipsis;
  whitespace: nowrap;
  font-family: Jura;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
const TermsValue = styled.div`
  color: #55CDC4;
  text-align: left;
  text-overflow: ellipsis;
  whitespace: nowrap;
  font-family: Jura;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  max-width: 140px;
`;

const PrimaryAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

    .primary-button {
      margin: 0px;
      height: 70px;
    }
`;

const PlayOriginalButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  
  border-radius: 36px;
  background: rgba(245, 225, 255, 0.6);
  outline: none;
  border: none;
  padding: 5px 10px;

  color: #000;
  text-align: center;
  text-overflow: ellipsis;
  font-family: Raleway;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.2s ease;
  
  .fa-play, .fa-pause {
    margin-right: 5px;
  }

  &:hover {
    background: rgba(245, 225, 255, 0.9);
  }
`;

const MainPlayButton = styled.button`
  position: absolute;
  top: calc(50% - 40px); //center by subtract self height
  left: calc(50% - 40px); //center by subtract self width
  width: 80px;
  height: 80px;
  
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  border-radius: 36px;
  background: none;
  outline: none;
  border: none;

  color: #FFF;
  text-align: center;
  text-overflow: ellipsis;
  font-family: Raleway;
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  
  
  .fa-play {
  }
  
  &:hover {
    background: #180d2399;

    .fa-play {
      color: #ff74e9;
    }
  }
`;

const MainPlayText = styled.div`
  position: absolute;
  top: calc(50% + 60px); //position below centered play button
  left: 0; //center by text-align
  width: 80px;
  height: 80px;
  
  color: rgba(245, 225, 255, 0.74);
  text-align: center;
  text-overflow: ellipsis;
  font-family: Raleway;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  text-shadow: 1px 1px 2px #0C0810;
  
  width: 100%;
`;

const NowPlayingWaveformIndicator = styled.span`
  display: inline-block;
  margin-right: 8px;
`;

const SongActionButton = styled(Button)`
  margin-top: 20px;
  justify-self: flex-end;
  
  &:disabled {
    opacity: 1;
  }
`